import React from 'react';

export interface StatusIndicatorStyle03Props {
  online: boolean;
  label?: string;
}

/**
 * StatusIndicator Style 03 - Outline
 * Bordered badge with outline style (no background fill)
 */
export const Style03_Outline: React.FC<StatusIndicatorStyle03Props> = ({
  online,
  label
}) => {
  return (
    <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border ${
      online 
        ? 'border-green-500 text-green-400' 
        : 'border-red-500 text-red-400'
    }`}>
      <span>{label || (online ? 'ONLINE' : 'OFFLINE')}</span>
    </div>
  );
};

export default Style03_Outline;
